var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurpleSqureDotsb6E7Dbcc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 133.838,
    height: 81.747,
    viewBox: "0 0 133.838 81.747",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)",
    opacity: 0.473
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.071,13.938a5.857,5.857,0,1,0-5.851-5.857A5.854,5.854,0,0,0,327.071,13.938Z",
    transform: "translate(-199.084 -2.224)",
    fill: "#7a3fe6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.071,24.643a5.857,5.857,0,1,0-5.851-5.857A5.854,5.854,0,0,0,327.071,24.643Z",
    transform: "translate(-199.084 10.416)",
    fill: "#7a3fe6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.071,35.348a5.857,5.857,0,1,0-5.851-5.857A5.854,5.854,0,0,0,327.071,35.348Z",
    transform: "translate(-199.084 23.055)",
    fill: "#7a3fe6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.071,46.052a5.857,5.857,0,1,0-5.851-5.857A5.854,5.854,0,0,0,327.071,46.052Z",
    transform: "translate(-199.084 35.695)",
    fill: "#7a3fe6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.868,13.938a5.857,5.857,0,1,0-5.849-5.857A5.854,5.854,0,0,0,315.868,13.938Z",
    transform: "translate(-212.309 -2.224)",
    fill: "#7a3fe6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.868,24.643a5.857,5.857,0,1,0-5.849-5.857A5.854,5.854,0,0,0,315.868,24.643Z",
    transform: "translate(-212.309 10.416)",
    fill: "#7a3fe6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.868,35.348a5.857,5.857,0,1,0-5.849-5.857A5.854,5.854,0,0,0,315.868,35.348Z",
    transform: "translate(-212.309 23.056)",
    fill: "#7a3fe6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.868,46.052a5.857,5.857,0,1,0-5.849-5.857A5.854,5.854,0,0,0,315.868,46.052Z",
    transform: "translate(-212.309 35.695)",
    fill: "#7a3fe6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.668,13.938a5.857,5.857,0,1,0-5.851-5.857A5.854,5.854,0,0,0,304.668,13.938Z",
    transform: "translate(-225.536 -2.224)",
    fill: "#7a3fe6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.668,24.643a5.857,5.857,0,1,0-5.851-5.857A5.854,5.854,0,0,0,304.668,24.643Z",
    transform: "translate(-225.536 10.416)",
    fill: "#7a3fe6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.668,35.348a5.857,5.857,0,1,0-5.851-5.857A5.854,5.854,0,0,0,304.668,35.348Z",
    transform: "translate(-225.536 23.055)",
    fill: "#7a3fe6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.668,46.052a5.857,5.857,0,1,0-5.851-5.857A5.854,5.854,0,0,0,304.668,46.052Z",
    transform: "translate(-225.536 35.695)",
    fill: "#7a3fe6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.467,13.938a5.857,5.857,0,1,0-5.851-5.857A5.853,5.853,0,0,0,293.467,13.938Z",
    transform: "translate(-238.761 -2.224)",
    fill: "#7a3fe6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.467,24.643a5.857,5.857,0,1,0-5.851-5.857A5.853,5.853,0,0,0,293.467,24.643Z",
    transform: "translate(-238.761 10.416)",
    fill: "#7a3fe6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.467,35.348a5.857,5.857,0,1,0-5.851-5.857A5.853,5.853,0,0,0,293.467,35.348Z",
    transform: "translate(-238.761 23.055)",
    fill: "#7a3fe6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.467,46.052a5.857,5.857,0,1,0-5.851-5.857A5.853,5.853,0,0,0,293.467,46.052Z",
    transform: "translate(-238.761 35.695)",
    fill: "#7a3fe6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.264,13.938a5.857,5.857,0,1,0-5.849-5.857A5.854,5.854,0,0,0,282.264,13.938Z",
    transform: "translate(-251.987 -2.224)",
    fill: "#7a3fe6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.264,24.643a5.857,5.857,0,1,0-5.849-5.857A5.854,5.854,0,0,0,282.264,24.643Z",
    transform: "translate(-251.987 10.416)",
    fill: "#7a3fe6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.264,35.348a5.857,5.857,0,1,0-5.849-5.857A5.854,5.854,0,0,0,282.264,35.348Z",
    transform: "translate(-251.987 23.055)",
    fill: "#7a3fe6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.264,46.052a5.857,5.857,0,1,0-5.849-5.857A5.854,5.854,0,0,0,282.264,46.052Z",
    transform: "translate(-251.987 35.695)",
    fill: "#7a3fe6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.064,13.938a5.857,5.857,0,1,0-5.851-5.857A5.854,5.854,0,0,0,271.064,13.938Z",
    transform: "translate(-265.213 -2.224)",
    fill: "#7a3fe6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.064,24.643a5.857,5.857,0,1,0-5.851-5.857A5.854,5.854,0,0,0,271.064,24.643Z",
    transform: "translate(-265.213 10.416)",
    fill: "#7a3fe6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.064,35.348a5.857,5.857,0,1,0-5.851-5.857A5.854,5.854,0,0,0,271.064,35.348Z",
    transform: "translate(-265.213 23.055)",
    fill: "#7a3fe6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.064,46.052a5.857,5.857,0,1,0-5.851-5.857A5.854,5.854,0,0,0,271.064,46.052Z",
    transform: "translate(-265.213 35.695)",
    fill: "#7a3fe6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleSqureDotsb6E7Dbcc);
export default __webpack_public_path__ + "static/media/purple_squre_dots.b6e7dbcc.63c5b6a7f95ac245cc251d763dc733fb.svg";
export { ForwardRef as ReactComponent };